import { environment } from '../../environments/environment';

export class TenantConstant {
    static readonly tenant = environment.tenant;
    static readonly branch = environment.branch;
    static readonly portal = environment.portal;
}